import { css, mixins } from '@bob/library'

export const spotCampaignBreakpoint = 1150

export interface SharedBackgroundProps {
  backgroundColor: string
}

export const SharedBackground = css<SharedBackgroundProps>`
  background: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${mixins.colors.grayLight};
  border-radius: 5px;
  overflow: hidden;
  position: relative;
`
